/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

const JAMA_URL = 'https://jamatimertrigger.azurewebsites.net/api'
const prod = {
  url: {
    // API_URL: 'https://argos-argosdev1func-dev.musea2.azure.ext.gm.com/api', // TEST SLOT
    // API_URL: 'https://argos-func-dev.musea2.azure.ext.gm.com/api', // RELEASE SLOT
    API_URL: 'http://localhost:7071/api',
    JAMA_URL: JAMA_URL
  }
};

const dev = {
  url: {
    API_URL: 'http://localhost:7071/api',
    JAMA_URL: JAMA_URL,
  }
};

export const config = process.env.NODE_ENV === 'development' ? dev : prod;